export default {
  vue: [
    {
      name: "Vue Cli 配置官网",
      herf: "https://cli.vuejs.org/zh/config/#vue-config-js",
    },
    { name: "Vue 官网", herf: "https://cn.vuejs.org/v2/guide/list.html" },
    { name: "Vue-router官网", herf: "https://router.vuejs.org/zh/guide/" },
    { name: "Vuex官网", herf: "https://vuex.vuejs.org/zh/guide/state.html" },
    {name:'vite官网',herf:"https://vitejs.dev/guide/"}
  ],
  react: [
    {
      name: "React官方文档",
      herf: "https://react.docschina.org/docs/getting-started.html",
    },
    { name: "Redux文档", herf: "https://www.redux.org.cn/" },
    { name: "MobX文档", herf: "https://cn.mobx.js.org/" },
    { name: "图解React", herf: "https://7kms.github.io/react-illustration-series/interview/01-setstate" },
    {name:'React-router教程案例v5',herf:'https://v5.reactrouter.com/web/guides/philosophy'},
    {name:'Reach-router教程案例',herf:'https://reach.tech/router/example/basic'},
    {name:'react在线练习',herf:'https://reach.tech/router/example/basic'},
    {name:'react全家桶分享',herf:'https://github.com/brickspert/blog/issues/1'}
  ],
  wechat: [
    {
      name: "微信小程序官网开发文档",
      herf: "https://developers.weixin.qq.com/miniprogram/dev/api/",
    },
    { name: "微信公众平台", herf: "https://mp.weixin.qq.com/" },
    { name: "微信开放平台", herf: "https://open.weixin.qq.com/" },
  ],
  uilib:[
    {
      name: "Antd官网",
      herf: "https://ant.design/components/overview-cn/",
    },
    {
      name: "ElementUI",
      herf: "https://element.eleme.cn/#/zh-CN/component/message",
    },
    {
      name: "AntdV官网",
      herf: "https://www.antdv.com/components/card-cn/",
    },
    {
      name: "Vant官网",
      herf: "https://vant-contrib.gitee.io/vant/#/zh-CN/switch",
      title:"有赞的移动端H5组件库"
    },
  ],
  tool:[
    {name:'腾讯云技术手册',
  herf:'https://cloud.tencent.com/developer/devdocs'},
    {
      name: "yapi接口平台",
      herf: "http://yapi.smart-xwork.cn/",
    },
    {
      name: "jd前端官网",
      herf: "http://fe.jd.com/",
    },
    {
      name: "swiperjs轮播图",
      herf: "https://swiperjs.com/demos",
    },
    {
      name: "在线生成AST",
      herf: "https://astexplorer.net/",
    },
    {
      name: "VsCode快捷键",
      herf: "https://www.cnblogs.com/qianguyihao/p/10732375.html",
    },
    {
      name: "清除浏览器默认样式",
      herf: "https://www.cnblogs.com/fitzlovecode/p/reset_css.html",
    },
    {
      name:'gitbook使用',
      herf:'https://www.jianshu.com/p/799a09add46c'
    }
  ],
  html:[
    {
      name: "MDN官网",
      herf: "https://developer.mozilla.org/zh-CN/docs/Web",
    },
    {
      name:'WebKit官网查询',
      herf:'https://webkit.org/css-status/#'
    },
    {
      name:'Chrome浏览器内核官网',
      herf:'http://www.chromium.org/Home'
    },
    {
      name:'Chrome DevTools',
      herf:'https://developer.chrome.com/docs/devtools/'
    },
    {
      name:'devtools调试库',
      herf:'https://devtools.glitch.me/network/getstarted.html'
    },
    {
      name:'Blob、FileReader和FormData的区别',
      herf:'https://cloud.tencent.com/developer/article/1525156'
    }
  ],
  javascript:[
    {
      name: "ES6入门",
      herf: "https://es6.ruanyifeng.com/#docs/async",
    },
    {
      name: "axios",
      herf: "http://www.axios-js.com/zh-cn/docs/",
      title:"发送http请求"
    },
    {
      name: "qs库",
      herf: "https://www.npmjs.com/package/qs",
      title:"querystring序列化和反序列化"
    },
    {
      name:'webpack教程',
      herf:'http://webpack.wuhaolin.cn/',
      title:'webpack电子教程'
    }
  ],
  dalao:[
    {
      name:'算法题解',
      herf:'https://programmercarl.com/'
    },
    {
      name:'shymean',
      herf:'https://www.shymean.com/'
    },
    {
      name: "ali-李金珂",
      herf: "https://www.lijinke.cn/archives/",
    },
    {
      name: "阮一峰技术博客",
      herf: "http://www.ruanyifeng.com/blog/",
    },
    {
      name: "面试资源",
      herf: "https://juejin.cn/post/6941546135827775525",
    },
    {
      name: "印记中文-前端工具推荐",
      herf: "https://docschina.org/",
    },
    {
      name: "前端工具合集",
      herf: "https://devtool.tech/",
    },
    {
      name: "前端进阶知识",
      herf: "https://q.shanyue.tech/",
    },
    {
      name: "千古前端图文教程",
      herf: "https://web.qianguyihao.com/",
    },
    {
      name: "千古前端导航",
      herf: "https://www.cnblogs.com/qianguyihao/p/10701923.html",
    },
    {
      name: "JS书籍测评",
      herf: "https://mp.weixin.qq.com/s/nffwL_ma1t30lr4ooyWARQ",
    },
    {
      name:'emoji在线生成',
      herf:'https://translate.yandex.com/?lang=zh-emj&text=%E4%B8%AD%E5%9B%BD'
    }
  ]
}
